/// <amd-module name="Test/TestFlaky/Actions/TestFlakyActionHub" />
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { Action } from "VSS/Reflux/Action";

export interface ITestRunTestCaseResultHolder {
    testRun: TCMContracts.TestRun;
    testCaseResult: TCMContracts.TestCaseResult;
    flakyIdentifiers?: TCMContracts.TestFlakyIdentifier[];
}

export class TestFlakyActionHub {
    public updateFlakyDialog = new Action<ITestRunTestCaseResultHolder>();
    public onDismiss = new Action<void>();
    public onError = new Action<string>();
}
